import { Component, Input, OnInit } from '@angular/core';
import { AcidificationStimulation } from 'src/app/interfaces/fracture';
import { HandoverService } from 'src/app/services/handover.service';

@Component({
  selector: 'app-handover-detail-acidification-stimulations',
  templateUrl: './handover-detail-acidification-stimulations.component.html',
  styleUrl: './handover-detail-acidification-stimulations.component.scss',
  standalone: false,
})
export class HandoverDetailAcidificationStimulationsComponent
  implements OnInit
{
  @Input() handoverId: number | undefined;
  @Input() wellName: string | undefined;
  @Input() handoverStatusId: number | undefined;

  acidificationStimulations: AcidificationStimulation[] = [];
  isLoading = false;
  hideFooter = true;
  displayedColumns = [
    'startDate',
    'top',
    'base',
    'type',
    'maximalSurfacePressure',
    'instantPressure',
    'finalSurfacePressure',
  ];

  constructor(public handoverService: HandoverService) {}

  ngOnInit(): void {
    if (this.handoverId && this.wellName) {
      this.isLoading = true;
      this.handoverService
        .getHandoverAcidificationStimulations(
          this.handoverId,
          this.wellName!,
          this.handoverStatusId!
        )
        .subscribe((ac: AcidificationStimulation[]) => {
          if (ac) {
            ac.sort((a, b) => a.top - b.top);
            this.acidificationStimulations = ac;
            this.hideFooter = this.acidificationStimulations!.length > 0;
          }
          this.isLoading = false;
        });
    }
  }
}
